<template>
  <div class="notice_list" :style="{height:clientHeight+'px'}">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了..." @load="onLoad" :immediate-check="false">
      <div class="notice_item" v-for="(item,index) in noticeListData" :key="index" @click="toNoticeDetail(item.articleId)">
        <div class="item_time">{{item.covertTime}}</div>
        <div class="item_card">
          <div class="card_title">{{item.noticeTitle}}</div>
          <div class="card_img">
            <img :src="item.imgUrl" alt="">
          </div>
          <div class="card_text">{{item.digest}}</div>
          <div class="card_bottom">阅读全文 <img src="../../assets/img/green_arrow.png" alt=""> </div>
        </div>
      </div>
    </van-list>

  </div>
</template>

<script>
export default {
  name: "notice-list",
  data() {
    return {
      // 列表数据源
      noticeListData: [],
      // 是否在加载中
      loading: true,
      // 是否已加载完成
      finished: false,
      pageIndex: 1,
      pageSize: 10,
      isMore: false
    };
  },
  mounted() {
    console.log(this.clientHeight, 'clientHeight');
    this.getNoticeList();
    // 防止列表页初次加载加载多次
    setTimeout(() => {
      this.isMore = true;
    }, 1000)
  },
  methods: {
    /**
     * 获取公告列表数据
     */
    getNoticeList() {
      this.loading = true;
      this.finished = false;
      this.$request.get(`/appserver/v1/notice/list?pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`).then((res) => {
        if (res.data.ret == 0) {
          let resList = res.data.data;
          if (resList) {
            let list = this.noticeListData;
            this.noticeListData = list.concat(res.data.data);
          }
          // 数据为空
          if (this.pageIndex == 1 && !resList && !resList.length == 0) {
            console.log('数据为空');
          }
          //   数据已加载完毕
          if ((!resList || resList.length == 0) && this.noticeListData.length > 0) {
            console.log('数据已加载完毕');
            this.finished = true;
          }
          this.loading = false;
        } else {
          this.loading = false;
          console.log('接口出错');
        }

      }).catch((e) => {
        console.log(e, '接口出错');
      });
    },
    /**
     * 跳转公告详情
     */
    toNoticeDetail(articleId) {
      this.$router.push({
        name: 'noticeDetail',
        query: {
          id: articleId,
          // 不显示全部列表按钮
          notAll: true
        }
      })
    },
    onLoad() {
      this.pageIndex++;
      this.getNoticeList();
    }
  },
  computed: {
    clientHeight() {
      return document.body.clientHeight
    }
  },
  filters: {}
};
</script>
<style lang="scss">
.notice_list {
  padding: 0 15px;
  background: #f2f2f2;
  overflow: auto;
  .notice_item {
    .item_time {
      text-align: center;
      padding: 15px 0px;
      color: #bfbfbf;
      font-size: 12px;
    }
    .item_card {
      background: white;
      padding: 0 15px;
      .card_title {
        padding: 15px 0;
        color: #262626;
        font-size: 16px;
        font-weight: bold;
      }
      .card_img {
        width: 100%;
        img {
          width: 100%;
          max-height: 150px;
        }
      }
      .card_text {
        color: #787878;
        font-size: 14px;
        letter-spacing: 0.5px;
        margin: 15px 0px;
        // border-bottom: 1px solid #f3f3f3;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        // padding-bottom: 15px;
        margin-bottom: 20px;
      }
      .card_bottom {
        height: 42px;
        color: #2ed07e;
        font-size: 14px;
        display: flex;
        align-items: center;
        border-top: 1px solid #f3f3f3;
        img {
          width: 10px;
          height: 15px;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
